import React from 'react';
import { useTheme } from 'next-themes';
import {
	brandName,
	VELOCITY_LOGO_DARK_SRC,
	VELOCITY_LOGO_SRC,
} from 'src/constants/constants';
import { VelocityTheme } from 'src/environmentVariables/EnvironmentVariableTypes';

type Props = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'>;

export default function VelocityGraphicLogo({
	alt = brandName,
	...props
}: Props) {
	const theme = (useTheme().theme as VelocityTheme) ?? VelocityTheme.dark;
	const src =
		theme === VelocityTheme.light ? VELOCITY_LOGO_SRC : VELOCITY_LOGO_DARK_SRC;

	return <img src={src} alt={alt} {...props} />;
}
